import { styled } from 'styled-components';

import UnreadBadgeContainer from '../../../../containers/unreadBadge';

export const BadgeIndicatorContainer = styled(UnreadBadgeContainer)`
  position: absolute;
  right: 0;
  top: var(--spacing-small);
`;
